import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { mediaUrl } from "@/lib/api";

// Editorial news row: thumbnail on one side, article information on the other.
// Stacks cleanly on mobile. Separated by a hairline rule in the listing.
export const NewsCard = ({ item }) => {
  const cover = item.coverMediaId ? mediaUrl(item.coverMediaId) : (item.coverUrl || null);
  const date = item.publishedAt
    ? new Date(item.publishedAt).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })
    : "";
  const meta = [date, item.category].filter(Boolean).join("  \u00b7  ");

  return (
    <Link
      to={`/news/${item.slug}`}
      data-testid="news-card"
      className="group grid grid-cols-1 gap-5 border-t py-8 first:border-t-0 first:pt-0 sm:grid-cols-[248px_1fr] sm:gap-8"
      style={{ borderColor: "var(--hairline)" }}
    >
      <div className="overflow-hidden rounded-[10px]" style={{ background: "var(--bg-elev-1)", border: "1px solid var(--card-border)", aspectRatio: "16 / 10" }}>
        {cover ? (
          <img src={cover} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
        ) : (
          <div className="flex h-full w-full items-center justify-center">
            <span className="motif-caps">{item.category || "News"}</span>
          </div>
        )}
      </div>
      <div className="flex flex-col justify-center">
        {meta && <p className="text-[11px] uppercase" style={{ color: "var(--fg-subtle)", letterSpacing: "0.18em" }}>{meta}</p>}
        <h3 className="mt-2 text-[20px] leading-snug sm:text-[23px]" style={{ color: "var(--text)", fontWeight: 500, letterSpacing: "0.2px" }}>{item.title}</h3>
        {item.excerpt && <p className="mt-2.5 max-w-[64ch] text-[14px] leading-[1.8]" style={{ color: "var(--muted)" }}>{item.excerpt}</p>}
        <span data-testid="news-card-readmore" className="mt-3.5 inline-flex items-center gap-1.5 text-[11px] uppercase" style={{ color: "var(--accent)", letterSpacing: "0.2em" }}>
          Read More <ArrowRight size={14} className="transition-transform duration-200 group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  );
};
